import { render } from "./ResultsLabel.vue?vue&type=template&id=937e0d56&scoped=true"
import script from "./ResultsLabel.vue?vue&type=script&lang=ts"
export * from "./ResultsLabel.vue?vue&type=script&lang=ts"

import "./ResultsLabel.vue?vue&type=style&index=0&id=937e0d56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-937e0d56"

export default script